import {
  AppointmentConfigurationControllerApi,
  AppointmentConfigurationDto,
} from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

type Params = {
  appointmentConfigurationDto: AppointmentConfigurationDto;
  xTENANTID?: string;
};

export const useAddAppointmentConfiguration = () =>
  useMutationWithLoading(async ({appointmentConfigurationDto,xTENANTID}: Params) =>
    new AppointmentConfigurationControllerApi(
      getConfigObject()
    ).addConfiguration2(
      appointmentConfigurationDto,
      xTENANTID
    )
  );
